import TabComponent2 from "../../components/tabs/yellowTab";
import { TabPanel } from "react-tabs";
import { tabDataPb } from "../../modules/data";
import { pbHealthBeautyBaby } from "../../modules/options";
import { pbHouseHold } from "../../modules/options";
import PackedBubbleChart from "../../components/packed-bubble-chart";

const PowerBrands = () => {
  return (
    <div className="demo-charts-demo">
      <TabComponent2 data={tabDataPb}>
        <TabPanel>
          <PackedBubbleChart options={pbHealthBeautyBaby} />
        </TabPanel>
        <TabPanel>
          <PackedBubbleChart options={pbHouseHold} />
        </TabPanel>
      </TabComponent2>
    </div>
  );
};

export default PowerBrands;
